<div class="form-group" [formGroup]="formGroup">
  <ng-container *ngIf="formGroupNameValue !== undefined; else elseTemplate">
    <div [formGroupName]="formGroupNameValue">
      <label class="control-label">{{label}}</label>
      <div class="input-group input-group-sm">
        <div class="input-group-prepend">
          <button class="btn btn-outline-secondary" type="button" (click)="changeValueClickEvent(true)"> - </button>
        </div>
        <input type="number" class="form-control" style="text-align: center" readonly="readonly"
          [formControlName]="formControlNameValue" name="{{name}}" id="{{id}}">
        <div class="input-group-prepend">
          <button class="btn btn-outline-secondary" type="button"
            (click)="changeValueClickEvent(false)">
            + </button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #elseTemplate>
    <label class="control-label">{{label}}</label>
    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <button class="btn btn-outline-secondary" type="button" (click)="changeValueClickEvent(true)"> - </button>
      </div>
      <input type="number" class="form-control" style="text-align: center" readonly="readonly"
        [formControlName]="formControlNameValue" name="{{name}}" id="{{id}}">
      <div class="input-group-prepend">
        <button class="btn btn-outline-secondary" type="button"
          (click)="changeValueClickEvent(false)">
          + </button>
      </div>
    </div>
  </ng-template>
</div>
